// @ts-expect-error esm import
import { cssToken } from '@cp/ui/utils';

export const name = 'Tariff';
export const Tokens = {
  RootBG: cssToken(name, ['color', 'bg']),
  BorderColor: cssToken(name, ['color', 'border']),
  BorderColorChecked: cssToken(name, ['color', 'border', 'checked']),
  Shadow: cssToken(name, ['shadow']),
  ShadowChecked: cssToken(name, ['shadow', 'checked']),
  BenefitBG: cssToken(name, ['color', 'benefit', 'bg']),
  BenefitFG: cssToken(name, ['color', 'benefit', 'fg']),
  TermFG: cssToken(name, ['color', 'term']),
};
